import { apiClient } from '../api/client';
import { API_PATHS } from '../api/endpoints';
import { mapTimestamps, mapTimestampsArray } from '../api/mapTimestamps';
import type { ApiListResponse, ApiItemResponse } from '../types/apiResponses';
import type { Client, CreateClientInput, UpdateClientInput } from '../types/client';

type BackendClient = Omit<Client, 'createdAt' | 'updatedAt'> & {
  created: string;
  lastModified: string;
};

export async function getClients(): Promise<Client[]> {
  const response = await apiClient.get<ApiListResponse<BackendClient>>(API_PATHS.clients);
  return mapTimestampsArray(response.items);
}

export async function getClientById(id: string): Promise<Client> {
  const response = await apiClient.get<ApiItemResponse<BackendClient>>(
    `${API_PATHS.clients}${id}`,
  );
  return mapTimestamps(response.item);
}

export async function createClient(input: CreateClientInput): Promise<Client> {
  const response = await apiClient.post<ApiItemResponse<BackendClient>>(
    API_PATHS.clients,
    input,
  );
  return mapTimestamps(response.item);
}

export async function updateClient(id: string, input: UpdateClientInput): Promise<Client> {
  const response = await apiClient.patch<ApiItemResponse<BackendClient>>(
    `${API_PATHS.clients}${id}`,
    input,
  );
  return mapTimestamps(response.item);
}

export async function deleteClient(id: string): Promise<void> {
  await apiClient.delete(`${API_PATHS.clients}${id}`);
}
